import { DeleteRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useGetDrinks } from "./useGetDrinks"
import { DrinkEntity } from "../../Objects/MealsAndDrinks/DrinkEntity"
import { useTranslation } from "react-i18next"

export const useRemoveDrink = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { handleGetDrinks } = useGetDrinks()

  const handleRemove = async (drink: DrinkEntity, onSuccess: any) => {
    try {
      enableLoad()

      var response = await DeleteRequest(`${API_ROUTES.DRINK.DELETE}/${drink.id}`)

      if (response.success) {
        await handleGetDrinks(onSuccess)

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleRemove,
  }
}
